var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlanStandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 64,
    viewBox: "0 0 60 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.691406 25.1803L15.2159 16.7869L29.7404 41.6175V64L0.691406 47.2131V25.1803Z",
    fill: "#33C475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7402 41.6175L58.7892 24.8306V47.2131L29.7402 64V41.6175Z",
    fill: "#2ED47A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5679 42.6667L13.833 17.6612L44.2653 0L60.0001 25.0055L29.5679 42.6667Z",
    fill: "#26AE64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8329 17.6611L0 25.53V27.1038L14.5245 18.7103L13.8329 17.6611Z",
    fill: "#278F57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9199 42.4919L47.3781 40.5684V46.164L43.9199 48.0875V42.4919Z",
    fill: "#23A25D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9189 42.492L46.8584 40.8582V45.8144L43.9189 47.3882V42.492Z",
    fill: "#1F7948"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2363 47.7377L37.6945 45.8142V51.4098L34.2363 53.3333V47.7377Z",
    fill: "#23A25D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2363 47.7376L37.1758 46.1038V51.0601L34.2363 52.6338V47.7376Z",
    fill: "#1F7948"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5645 37.5956L56.0227 35.6721V41.2677L52.5645 43.1912V37.5956Z",
    fill: "#23A25D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5645 37.5956L55.5039 35.9617V40.918L52.5645 42.4917V37.5956Z",
    fill: "#1F7948"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanStandard);
export default __webpack_public_path__ + "static/media/icon-plan-standard.c401da78.svg";
export { ForwardRef as ReactComponent };